// overlays/TextMarker.ts
export function createTextMarker(
	position: google.maps.LatLng,
	text: string,
	inactive: boolean = false
): google.maps.OverlayView {
	class TextMarker extends google.maps.OverlayView {
		element: HTMLElement | null = null;

		constructor(public position: google.maps.LatLng, public text: string) {
			super();
		}

		onAdd() {
			this.element = document.createElement("div");
			this.element.className = "hhds-map-textmarker";

			if (inactive) {
				this.element.classList.add("hhds-map-textmarker__inactive");
			}

			this.element.innerText = this.text;
			const panes = this.getPanes();
			panes?.overlayMouseTarget.appendChild(this.element);
		}

		draw() {
			if (!this.element) return;

			const projection = this.getProjection();
			const pos = projection.fromLatLngToDivPixel(this.position);

			const zoom = this.getMap()?.getZoom();
			if (zoom) {
				if (zoom <= 16) {
					this.element.style.display = "none";
				} else if (zoom < 18) {
					this.element.style.fontSize = "7px";
					this.element.style.fontWeight = "normal";
					this.element.style.display = "inherit";
				} else {
					this.element.style.fontSize = "12px";
					this.element.style.fontWeight = "bold";
					this.element.style.display = "inherit";
				}
			}

			if (pos) {
				this.element.style.left = `${pos.x}px`;
				this.element.style.top = `${pos.y}px`;
			}
		}

		onRemove() {
			if (this.element && this.element.parentNode) {
				this.element.parentNode.removeChild(this.element);
			}
			this.element = null;
		}
	}

	return new TextMarker(position, text);
}
